import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import _ from 'lodash';
import moment from 'moment';
import { numberFormat } from 'utils/app.utils';

async function ExportToExcel({ title, data, branchName, dateStart, dateEnd, operative, t,
}: { title: string, data: any[]; branchName: string; dateStart: string; dateEnd: string; operative: string; t: any }) {
    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet(title)

    // Title
    const titleRow = sheet.addRow([title])
    titleRow.font = { bold: true, size: 16 }
    sheet.mergeCells(titleRow.number, 1, titleRow.number, 10)
    titleRow.alignment = { horizontal: 'left' }

    // Filters
    const filterRow = sheet.addRow([
        `${t('REPORT.TABLE.DECREASE.BRANCH')}: ${branchName || '-'}  ${t('REPORT.TABLE.DECREASE.DATE_START')}: ${dateStart || '-'}  ${t('REPORT.TABLE.DECREASE.DATE_END')}: ${dateEnd || '-'}  ${t('REPORT.TABLE.FOLLOW_UP.OPERATIVE_TYPE')}: ${operative || '-'}`
    ])
    filterRow.font = { size: 11 }
    sheet.mergeCells(filterRow.number, 1, filterRow.number, 10)
    const headCells = [
        { label: t('REPORT.TABLE.PROFIT_SUMMARY.NO'), width: 8 },
        { label: t('REPORT.TABLE.PROFIT_SUMMARY.TREATMENT_CODE'), width: 18 },
        { label: t('REPORT.TABLE.PROFIT_SUMMARY.TREATMENT_NAME'), width: 30 },
        { label: t('REPORT.TABLE.PROFIT_SUMMARY.COST_PER_SESSION'), width: 16 },
        { label: t('REPORT.TABLE.PROFIT_SUMMARY.PRICE_PER_SESSION'), width: 14 },
        { label: t('REPORT.TABLE.PROFIT_SUMMARY.QUANTITY'), width: 16 },
        { label: t('REPORT.TABLE.PROFIT_SUMMARY.TOTAL_COST'), width: 16 },
        { label: t('REPORT.TABLE.PROFIT_SUMMARY.TOTAL_PAID'), width: 16 },
        { label: t('REPORT.TABLE.PROFIT_SUMMARY.TOTAL_PAYMENT'), width: 16 },
        { label: t('REPORT.TABLE.PROFIT_SUMMARY.TOTAL_PROFIT'), width: 22 },
        { label: t('REPORT.TABLE.PROFIT_SUMMARY.NET_PROFIT'), width: 14 }
    ]
    sheet.columns = headCells.map(c => ({ width: c.width }))
    const headerRow = sheet.addRow(headCells.map(c => c.label))
    headerRow.font = { bold: true, size: 12 }

    headerRow.eachCell((cell, colNumber) => {
        if (colNumber === 3) {
            cell.alignment = { horizontal: 'left', vertical: 'middle' }
        } else if ([1, 2, 4, 5, 6, 7, 8, 9, 10].includes(colNumber)) {
            cell.alignment = { horizontal: 'center', vertical: 'middle' }
        }
    })
    if (!data || data.length === 0) {
        const noDataRow = sheet.addRow([t('REPORT.TITLE.NO_DATA')])
        sheet.mergeCells(noDataRow.number, 1, noDataRow.number, headCells.length)
        noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
        noDataRow.alignment = { horizontal: 'center' }
    } else {
        data.forEach((row: any, idx: number) => {
            const newRow = sheet.addRow([
                idx + 1,
                row.operativeCode || '-',
                row.operativeName || '-',
                numberFormat(row.costPerUnit, 2),
                numberFormat(row.listPricePerUnit, 2),
                Number(row.qty) || 0,
                numberFormat(row.totalCost, 2),
                numberFormat(row.totalListPrice, 2),
                numberFormat(row.totalPaid, 2),
                numberFormat(row.grossProfit, 2),
                numberFormat(row.netProfit, 2),
            ])

            newRow.eachCell((cell, colNumber) => {
                if ([1, 2, 6].includes(colNumber)) {
                    cell.alignment = { horizontal: 'center' }
                } else if (colNumber === 3) {
                    cell.alignment = { horizontal: 'left' }
                } else if ([4, 5, 7, 8, 9, 10].includes(colNumber)) {
                    cell.alignment = { horizontal: 'right' }
                }
            })
        })


        const sumRow = sheet.addRow([
            t('REPORT.TITLE.SUM'), '', '',
            numberFormat(_.sumBy(data, 'costPerUnit') || 0, 2),
            numberFormat(_.sumBy(data, 'listPricePerUnit') || 0, 2),
            _.sumBy(data, (item: any) => Number(item.qty)) || 0,
            numberFormat(_.sumBy(data, 'totalCost') || 0, 2),
            numberFormat(_.sumBy(data, 'totalListPrice') || 0, 2),
            numberFormat(_.sumBy(data, 'totalPaid') || 0, 2),
            numberFormat(_.sumBy(data, 'grossProfit') || 0, 2),
            numberFormat(_.sumBy(data, 'netProfit') || 0, 2),
        ])
        sumRow.font = { bold: true }
        sumRow.alignment = { horizontal: 'right' }
        sheet.mergeCells(sumRow.number, 1, sumRow.number, 3)
    }

    // Save file
    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    saveAs(blob, `${title}_${moment().format('YYYYMMDD')}.xlsx`)
}

export default ExportToExcel 